(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── 1. Parse brand data ─────────────────────────────── */
  var dataEl = document.getElementById('bp-brands-data');
  var ALL_BRANDS = [];
  try {
    ALL_BRANDS = JSON.parse(dataEl.textContent || dataEl.innerHTML);
  } catch (e) {
    console.warn('HeathenBrands: JSON parse error', e);
    return;
  }

  /* ── 2. Read active filters from URL on page load ────── */
  function getURLParams() {
    var params = { category: [], gender: [], score: [], status: [] };
    var search = window.location.search;
    if (!search) return params;
    search.slice(1).split('&').forEach(function (pair) {
      var kv = pair.split('=');
      var key = decodeURIComponent(kv[0] || '');
      var val = decodeURIComponent(kv[1] || '');
      if (key === 'category[]') params.category.push(val);
      else if (key === 'gender[]') params.gender.push(val);
      else if (key === 'score[]') params.score.push(val);
      else if (key === 'status[]') params.status.push(val);
    });
    return params;
  }

  /* ── 3. State ────────────────────────────────────────── */
  var state = {
    search: '',
    letter: null,
    filters: getURLParams()   /* live filter state */
  };

  /* ── 4. DOM refs ─────────────────────────────────────── */
  var container   = document.getElementById('bp-brands-container');
  var noResults   = document.getElementById('bp-no-results');
  var searchInput = document.getElementById('bp-search-input');
  var azNav       = document.getElementById('bp-az-nav');
  var sidebar     = document.querySelector('.brands-page-section .filters-sidebar');
  var mobileBtn   = document.getElementById('bp-mobile-toggle');
  var closeBtn    = document.getElementById('bp-mobile-close');

  /* ── 5. Restore checkbox states from URL ─────────────── */
  function restoreCheckboxes() {
    document.querySelectorAll('.bp-filter-check').forEach(function (cb) {
      var group = cb.getAttribute('data-group');
      if (state.filters[group] && state.filters[group].indexOf(cb.value) !== -1) {
        cb.checked = true;
        cb.closest('.filter-checkbox').classList.add('is-active');
      }
    });
    // Open sections that have checked items
    ['bp-cat','bp-gender','bp-score','bp-status'].forEach(function (id) {
      var content = document.getElementById(id);
      if (!content) return;
      if (content.querySelector('input:checked')) {
        content.classList.remove('collapsed');
        content.classList.add('open');
        var title = content.previousElementSibling;
        if (title) { title.classList.remove('collapsed'); title.classList.add('open'); }
      }
    });
  }

  /* ── 6. Collect current checkbox state ──────────────── */
  function collectFilters() {
    var f = { category: [], gender: [], score: [], status: [] };
    document.querySelectorAll('.bp-filter-check:checked').forEach(function (cb) {
      var g = cb.getAttribute('data-group');
      if (f[g]) f[g].push(cb.value);
    });
    return f;
  }

  /* ── 7. Build products URL with current filters ──────── */
function buildFilterURL(brandURL, filters) {
  if (
    brandURL &&
    brandURL !== '#' &&
    !/^https?:\/\//i.test(brandURL)
  ) {
    var language = (document.documentElement.lang || '').toLowerCase();
    var isEnglish =
      language === 'en' ||
      language.indexOf('en-') === 0 ||
      window.location.pathname === '/en' ||
      window.location.pathname.indexOf('/en/') === 0;

    if (
      isEnglish &&
      brandURL.charAt(0) === '/' &&
      brandURL.indexOf('/en/') !== 0
    ) {
      brandURL = '/en' + brandURL;
    }
  }

  if (
    brandURL &&
    brandURL !== '#' &&
    !/^https?:\/\//i.test(brandURL)
  ) {
    var markerSeparator = brandURL.indexOf('?') === -1 ? '?' : '&';
    brandURL = brandURL + markerSeparator + 'from=brands';
  }

  var params = [];


  ['category', 'gender', 'score', 'status'].forEach(function (g) {
    (filters[g] || []).forEach(function (v) {
      params.push(
        encodeURIComponent(g + '[]') + '=' + encodeURIComponent(v)
      );
    });
  });

  if (!params.length) return brandURL;

  var sep = brandURL.indexOf('?') === -1 ? '?' : '&';
  return brandURL + sep + params.join('&');
}

/* ── 8. Filter brands by active state ───────────────── */
function getFirstChar(name) {
  var c = name.trim().charAt(0).toUpperCase();
  return /[0-9]/.test(c) ? '0-9' : c;
}


  function brandMatchesFilters(brand, filters) {
    /* If no filters active → show all */
    var hasAny = filters.category.length || filters.gender.length ||
                 filters.score.length   || filters.status.length;
    if (!hasAny) return true;

    /* Brand metadata fields (from the pipe-separated brands_list) */
    var bcat    = (brand.category || '').toLowerCase();
    var bgender = (brand.gender   || '').toLowerCase();
    var bscore  = (brand.score    || '').toLowerCase();
    var bstatus = (brand.status   || '').toLowerCase();

    /* Each active group must match (AND logic between groups, OR within group) */
    if (filters.category.length) {
      var ok = filters.category.some(function (v) { return bcat.indexOf(v) !== -1; });
      if (!ok) return false;
    }
    if (filters.gender.length) {
      var ok = filters.gender.some(function (v) { return bgender.indexOf(v) !== -1; });
      if (!ok) return false;
    }
    if (filters.score.length) {
      var ok = filters.score.some(function (v) { return bscore.indexOf(v) !== -1; });
      if (!ok) return false;
    }
    if (filters.status.length) {
      var ok = filters.status.some(function (v) { return bstatus.indexOf(v) !== -1; });
      if (!ok) return false;
    }
    return true;
  }

  function getFiltered() {
    var q = state.search.trim().toLowerCase();
    return ALL_BRANDS.filter(function (b) {
      var ms = !q || b.name.toLowerCase().indexOf(q) !== -1;
      var ml = !state.letter || getFirstChar(b.name) === state.letter;
      var mf = brandMatchesFilters(b, state.filters);
      return ms && ml && mf;
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name, 'pl', { sensitivity: 'base' });
    });
  }

  /* ── 9. Escape helpers ───────────────────────────────── */
  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── 10. Render brands ───────────────────────────────── */
  function render() {
    var filtered = getFiltered();

    if (!filtered.length) {
      container.innerHTML = '';
      noResults.style.display = '';
      return;
    }
    noResults.style.display = 'none';

    var groups = {}, order = [];
    filtered.forEach(function (b) {
      var ltr = getFirstChar(b.name);
      if (!groups[ltr]) { groups[ltr] = []; order.push(ltr); }
      groups[ltr].push(b);
    });
    order.sort(function (a, b) {
      if (a === '0-9') return -1; if (b === '0-9') return 1;
      return a.localeCompare(b);
    });

    var html = '';
    order.forEach(function (ltr) {
      html += '<div class="brand-letter-section" id="bp-sec-' + ltr + '">';
      html += '<h2 class="brand-letter">' + esc(ltr) + '</h2>';
      html += '<div class="brand-list">';
      groups[ltr].forEach(function (b) {
        var href = buildFilterURL(b.url, state.filters);
        html += '<a href="' + esc(href) + '" class="brand-item">' + esc(b.name) + '</a>';
      });
      html += '</div></div>';
    });

    container.innerHTML = html;
    updateAZNav(groups);
  }

  /* ── 11. A-Z nav ─────────────────────────────────────── */
  function updateAZNav(groups) {
    azNav.querySelectorAll('.alphabet-link').forEach(function (link) {
      var ltr = link.getAttribute('data-letter');
      if (ltr === 'all') return;
      link.classList.toggle('no-brands', !(groups && groups[ltr]));
    });
  }

  function setActiveAZ(letter) {
    azNav.querySelectorAll('.alphabet-link').forEach(function (l) { l.classList.remove('active'); });
    var sel = letter ? '[data-letter="' + letter + '"]' : '[data-letter="all"]';
    var el = azNav.querySelector(sel);
    if (el) el.classList.add('active');
  }

  azNav.addEventListener('click', function (e) {
    var link = e.target.closest('.alphabet-link');
    if (!link || link.classList.contains('no-brands')) return;
    e.preventDefault();
    var ltr = link.getAttribute('data-letter');
    state.letter = ltr === 'all' ? null : ltr;
    state.search = ''; searchInput.value = '';
    setActiveAZ(state.letter);
    render();
    if (state.letter) {
      var sec = document.getElementById('bp-sec-' + state.letter);
      if (sec) setTimeout(function () { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
    }
  });

  /* ── 12. Search ──────────────────────────────────────── */
  searchInput.addEventListener('input', function () {
    state.search = this.value;
    if (state.search.trim()) { state.letter = null; setActiveAZ(null); }
    render();
  });

  /* ── 13. Filter toggles (collapsible sections) ───────── */
  document.querySelectorAll('.brands-page-section .filter-title').forEach(function (title) {
    title.addEventListener('click', function () {
      var targetId = this.getAttribute('data-toggle');
      var content  = document.getElementById(targetId);
      if (!content) return;
      var isOpen = content.classList.contains('open');
      content.classList.toggle('open', !isOpen);
      content.classList.toggle('collapsed', isOpen);
      this.classList.toggle('open', !isOpen);
      this.classList.toggle('collapsed', isOpen);
    });
  });

  /* ── 14. Checkbox change → update filter state → render ─ */
  document.querySelectorAll('.bp-filter-check').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var group = this.getAttribute('data-group');
      this.closest('.filter-checkbox').classList.toggle('is-active', this.checked);
      state.filters = collectFilters();
      render();
      /* Also update URL so page can be shared / refreshed */
      updateURL();
    });
  });

  /* ── 15. Sync URL with current filter state ──────────── */
  function updateURL() {
    var params = [];
    ['category','gender','score','status'].forEach(function (g) {
      (state.filters[g] || []).forEach(function (v) {
        params.push(encodeURIComponent(g + '[]') + '=' + encodeURIComponent(v));
      });
    });
    var newSearch = params.length ? '?' + params.join('&') : window.location.pathname;
    history.replaceState(null, '', newSearch || window.location.pathname);
  }

  /* ── 16. Mobile sidebar ──────────────────────────────── */
  if (mobileBtn && sidebar) {
    mobileBtn.addEventListener('click', function () {
      sidebar.classList.toggle('is-open');
    });
  }
  if (closeBtn && sidebar) {
    closeBtn.addEventListener('click', function () {
      sidebar.classList.remove('is-open');
    });
  }

  /* ── 17. Init ────────────────────────────────────────── */
  restoreCheckboxes();
  render();

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
